import type { WireframeCookieConsentType } from '@app/core-features/wireframe/wireframe-types';

export type CookiesMapped = {
    bpm: null | string;
    c24appversion: null | string;
    c24cams: null | string;
    c24consent: WireframeCookieConsentType | null;
    c24indiappversion: null | string;
    c24sab: null | string;
    c24session: null | string;
    c24splash: null | string;
    c24webview: 'indi' | null; // only set by app when in indi webview
    csCode: null | string;
    deviceinfo: string;
    deviceoutput: Deviceoutput;
    devicetype: Deviceoutput;
    indiFeatureFlags: null | string;
    indiSession: null | string;
    indiSplash: null | string;
    playwrightContext: null | string;
    ppset: null | string;
    tid: null | string;
    wpset: null | string;
    xppset: null | string;
};

// order matters here
/* eslint-disable perfectionist/sort-objects */
export const DEVICEOUTPUT_RECORD = {
    desktop: 'desktop',
    mobile: 'mobile',
    app: 'app',
    tablet: 'tablet',
    tabletapp: 'tabletapp',
    DANGEROUS_android: 'android',
    DANGEROUS_ios: 'ios',
} as const;
/* eslint-enable perfectionist/sort-objects */

export type DeviceOSMapped = 'android' | 'ios' | 'other';

export type Deviceoutput = (typeof DEVICEOUTPUT_RECORD)[keyof typeof DEVICEOUTPUT_RECORD];

export type DeviceoutputMapped = 'desktop' | 'mobile';

export type CookiesUnmapped = Record<string, string>;

export const APP_SESSION_COOKIE_NAME = 'indiSession';
